const titleOptions = [
  'lawyer',
  'notary',
  'lawyer_and_notary',
  'non_lawyer_graduate',
];
export default { titleOptions };
